// Remembers every show summary the app has already received (Home, Explore, search, Up next…),
// so a show page can paint its header instantly from what is on screen while the episode list loads.
import type { Show } from './types';

const bySlug = new Map<string, Show>();
const byId = new Map<string, Show>();

function isShow(x: unknown): x is Show {
  const o = x as Show;
  return !!o && typeof o === 'object' && typeof o.id === 'string' && typeof o.slug === 'string' && typeof o.title === 'string' && typeof o.color === 'string';
}

/** Walk an API result and remember any show objects inside it (depth-limited). */
export function rememberShows(value: unknown, depth = 0): void {
  if (!value || depth > 4) return;
  if (Array.isArray(value)) { value.forEach((v) => rememberShows(v, depth + 1)); return; }
  if (typeof value !== 'object') return;
  if (isShow(value)) { bySlug.set(value.slug, value); byId.set(value.id, value); }
  for (const v of Object.values(value as Record<string, unknown>)) if (v && typeof v === 'object') rememberShows(v, depth + 1);
}

export function showSummary(slugOrId: string): Show | undefined {
  return bySlug.get(slugOrId) || byId.get(slugOrId);
}
